import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import GetCurrency from "../../../helper/GetCurrency";
import React from "react";
import withIntl from "../../../utils/withIntl";
import withStyles from "@material-ui/core/styles/withStyles";

function RowsVat(props) {
  const StyledCellVat = withStyles((theme) => ({
    body: {
      backgroundColor: props.total ? "#edeff8" : "#FFF",
      color: theme.palette.common.black,
      border: "none",
      verticalAlign: "text-top",
      padding: 6,
      textAlign: "right",
    },
  }))(TableCell);

  return (
    <>
      {!props.isTip &&
        Object.keys(props.amountsObject.vats).map((vat) => {
          if (vat === "count") {
            return null;
          }
          return (
            <TableRow>
              <StyledCellVat />
              <StyledCellVat />
              <StyledCellVat />
              <StyledCellVat>{vat * 100} %</StyledCellVat>
              <StyledCellVat>
                {GetCurrency() + " " + (props.amountsObject.vats[vat].amountExVat / 100.0).toFixed(2)}
              </StyledCellVat>
              <StyledCellVat>
                {GetCurrency() + " " + (props.amountsObject.vats[vat].amountVat / 100.0).toFixed(2)}
              </StyledCellVat>
              <StyledCellVat>
                {GetCurrency() + " " + (props.amountsObject.vats[vat].amountIncVat / 100.0).toFixed(2)}
              </StyledCellVat>
            </TableRow>
          );
        })}

      <TableRow>
        <StyledCellVat />
        <StyledCellVat />
        <StyledCellVat />
        <StyledCellVat style={{ fontWeight: "600" }}>
          {props.isTip && props.intl.formatMessage({ id: "Tip" })}
          {props.isSubtotal && props.intl.formatMessage({ id: "subtotal" })}
          {props.isTotal && props.intl.formatMessage({ id: "total" })}
        </StyledCellVat>
        <StyledCellVat style={{ fontWeight: "600" }}>
          {!props.isTip && GetCurrency() + " " + (props.amountsObject.total.amountExVat / 100.0).toFixed(2)}
        </StyledCellVat>
        <StyledCellVat style={{ fontWeight: "600" }}>
          {!props.isTip && GetCurrency() + " " + (props.amountsObject.total.amountVat / 100.0).toFixed(2)}
        </StyledCellVat>
        <StyledCellVat style={{ fontWeight: "600" }}>
          {!props.isTip && GetCurrency() + " " + (props.amountsObject.total.amountIncVat / 100.0).toFixed(2)}
          {props.isTip && GetCurrency() + " " + (props.amountsObject.tipAmount / 100.0).toFixed(2)}
        </StyledCellVat>
      </TableRow>
    </>
  );
}

export default withIntl(RowsVat);
